module.exports = __webpack_public_path__ + "assets/img/00149.37472101.png";